"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const SiteBackdrop = dynamic(
  () => import("./SiteBackdrop").then((m) => ({ default: m.SiteBackdrop })),
  { ssr: false },
);

/** Mount the heavy motherboard backdrop after first paint to protect LCP. */
export function DeferredSiteBackdrop() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const mount = () => setReady(true);
    if (window.matchMedia("(max-width: 768px)").matches) return;
    if (typeof requestIdleCallback === "function") {
      const id = requestIdleCallback(mount, { timeout: 2500 });
      return () => cancelIdleCallback(id);
    }
    const id = window.setTimeout(mount, 120);
    return () => window.clearTimeout(id);
  }, []);

  if (!ready) return null;
  return <SiteBackdrop />;
}
